import React from 'react';

function EmptyContentPlaceholder(props) {
    return (
        <div style={props.containerStyle}>
            <div style={props.style}>
                <div className="cover--bg placeholder">
                    <div className="cover__content">{props.children}</div>
                </div>
            </div>
        </div>
    );
}

function EmptyPlaceholder(props) {
    const style = { minHeight: props.minHeight || '40px', minWidth: props.minWidth || '10px' };
    if (props.fullWidth) {
        style.width = '100%';
    }
    return <div style={style} />
}

export {
    EmptyContentPlaceholder,
    EmptyPlaceholder
};

